import { useEffect, useState } from 'react'

import { ConfirmDialog } from '@/shared/ui/ConfirmDialog'

export const DigitalProductStoreRefundConfirmModal = ({
  onHide,
  onCancel,
  onConfirm
}) => {
  const [isWaitingRead, setIsWaitingRead] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsWaitingRead(false)
    }, 1500)

    return () => clearTimeout(timer)
  }, [])

  return (
    <ConfirmDialog
      variant="destructive"
      title="Atenção!"
      description={
        <>
          <span className="mb-1 block text-base font-bold text-gray-900">
            Você tem certeza que quer cancelar a reserva?
          </span>
          Após a confirmação, o item voltará para o estoque
        </>
      }
      confirmLabel="Confirmar"
      confirmLoading={isWaitingRead}
      onCancel={() => {
        onCancel()
        onHide()
      }}
      onConfirm={() => {
        onConfirm()
        onHide()
      }}
    />
  )
}
